export const SPECIAL_CHARACTER_ID = 'misc';
export const SEO_URL_META_DATA = 'https://www.xing.com/people/';
